export interface IParentPropertySubType {
  propertyTypeName: string;
  subTypes: IPropertySubType[];
  propertyTypeId: number;
}

/**
 * Used for Agent Commissions.
 */
export interface IPropertySubType {
  propertySubTypeId: number;
  name: string;
  isEdited: boolean;
  subTypeTableId?: number;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertySubTypeFactory = {
  getDefaultSubType({ propertyTypeId }: { propertyTypeId: number }): IPropertySubType {
    return {
      name: '',
      subTypeTableId: propertyTypeId,
      propertySubTypeId: 0,
      isEdited: true,
    };
  },
};
